import axios from "axios";
import { urls } from "../../config/constants";

const externalLogin = async (service, info) => {
  try {
    const response = await axios.post(
      `${urls.api}/users/login/${service}`,
      info
    );
    return response.data;
  } catch (error) {
    //console.error("Error logging in:", error);
    return null;
  }
};

const register = async (userInfo) => {
  try {
    const response = await axios.post(`${urls.api}/users`, userInfo);

    return response.data;
  } catch (error) {
    //console.error("Error registering:", error);
    throw error;
  }
};

const login = async (userInfo) => {
  try {
    const response = await axios.post(`${urls.api}/users/login`, userInfo);
    return response.data;
  } catch (error) {
    //console.error("Error logging in:", error);
    return null;
  }
};

export { register, externalLogin, login };
